import React, {useState, useEffect} from 'react';
import {Button, Drawer, Box, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AlarmDashboard from '../alarms/AlarmDashboard';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import {styled} from '@mui/material/styles';
import Badge, {badgeClasses} from '@mui/material/Badge';

export default function AlarmsDrawer({trafficLights = [], alarms, zones, tags, onUpdate, allTags, disabled, availableModels, initialCaption, selectedHornId}) {

    if (allTags.length === 0) {
        // show loading
        return (
            <div>Loading...</div>
        );
    }
    const [show, setShow] = React.useState(false);
    const [displayInfo, setDisplayInfo] = React.useState({});
    const [baseCaptioningFlag, setBaseCaptioningFlag] = useState(initialCaption);

    // Listen for new zones via window event
    useEffect(() => {
        const handleSelectedModelUpdated = (event) => {
            console.log("Received selected model update:", event.detail);
            if (event.detail?.captioning !== undefined) {
                setBaseCaptioningFlag(event.detail.captioning);
            }
        }

        window.addEventListener("selectedModel:updated", handleSelectedModelUpdated);

        // Cleanup function
        return () => {
            window.removeEventListener("selectedModel:updated", handleSelectedModelUpdated);
        };
    }, []); // Run once on mount

// when zones and tags change we need to update the display info
    useEffect(() => {
        function classIdToClass(class_id) {
            // go over alltags and find by id the class
            let found = allTags.find(tag => tag.id == class_id);
            if (found) {
                return found;
            } else {
                return {name: class_id};
            }
        }

        let mappedTags = tags.map(tag => {
            let classObj = classIdToClass(tag.value);
            return {
                value: tag.value,
                text: "Entire Image: "+tag.text,
                tag: classObj
            };
        });
        let displaydata = [];
        let index = 0;
        displaydata.push({
            zone: {
                value: index++,
                id: -1,
                caption: baseCaptioningFlag,
                label: 'Entire Image',

            },
            data: {
                objects: mappedTags,
                analizedData: []
            }
        });

        zones.forEach(zone => {
            let tagsData = [...mappedTags] || [];
            let analizedData = [];
            if (zone.model_classes && zone.model_classes.length > 0) {
                zone.model_classes.forEach((cls) => {
                    let class_id = cls;
                    let classObj = classIdToClass(class_id);
                    // @todo get the class name based on the class id
                    let class_name = classObj.name;
                    if (class_name !== '') {
                        // check if the class is already in the tagsData
                            tagsData.push({
                                value: class_id,
                                text: "Zona:" + class_name,
                                tag: classObj
                            });
                    }
                });
            }
            if (zone.analyzers && zone.analyzers.length > 0) {
                analizedData = zone.analyzers.map((analyzer) => {
                    let class_name = '';
                    let class_id = analyzer.class;

                    let classObj = classIdToClass(class_id);
                    class_name = classObj.name;
                    // if (class_name !== '') {
                    //     // check if the class is already in the tagsData
                    //     let found = tagsData.find(tag => tag.value === class_id);
                    //     if (!found) {
                    //         tagsData.push({
                    //             value: class_id,
                    //             text: "Analize:" + class_name,
                    //             tag: classObj
                    //         });
                    //     }
                    // }
                    return {
                        model: analyzer.model,
                        name: analyzer.name,
                        hint: analyzer.hint,
                        hint_file_url: analyzer.hint_file_url,
                        class_id: class_id,
                        class_name: class_name,
                        tag: classObj
                    };
                });
            }
            // add detector classes
            if (zone.detectors && zone.detectors.length > 0) {
                zone.detectors.forEach(detector => {
                    let class_name = '';
                    let class_id = detector.class;
                    let class_value = 'D-' + class_id;
                    // @todo get the class name based on the class id

                    let classObj = classIdToClass(class_id);
                    let baseName ="Detector name "+ detector.name +"("+detector.model+"): "+ '[' + classObj.name;
                    let baseId = 'D-'+class_id;

                    // let founds = tagsData.find(tag => tag.value === 'D-'+class_id);
                    let baseTag = classObj;
                    // if (!founds) {
                    //     tagsData.push({
                    //         value: baseId,
                    //         text: baseName+']',
                    //         tag: classObj
                    //     });
                    // }

                    class_name = baseName;
                    let tags = [];
                    detector.classes.forEach((cls) => {
                        let class_id = cls;
                        let classObj = classIdToClass(class_id);
                        // @todo get the class name based on the class id
                        class_name += '-' + classObj.name;
                        // let found = tagsData.find(tag => tag.value === baseId+'-'+class_id);
                            // if (!found) {
                                tagsData.push({
                                    value: baseId+'-'+class_id,
                                    text: baseName + '-'+classObj.name+']',
                                    tag: baseTag,
                                    tags:[classObj]
                                });
                            // }
                        class_value += '-' + class_id;
                        tags.push(classObj);
                    });

                    class_name += ']';
                    // // check if the class is already in the tagsData
                    // let found = tagsData.find(tag => tag.value === class_value);
                    // if (!found) {
                    //     tagsData.push({
                    //         value: class_value,
                    //         text: class_name,
                    //         tag: classObj,
                    //         tags: tags,
                    //         classes:detector.classes
                    //     });
                    // }

                });
            }
            // add union classes
            if (zone.union && zone.union.length > 0) {
                zone.union.forEach(union => {
                    let class_name = '';
                    let class_id = union[0];
                    let class_value = 'U-' + class_id;
                    // @todo get the class name based on the class id
                    let classObj = classIdToClass(class_id);
                    class_name = 'Union: [' + classObj.name;
                    let tags = [];
                    union[1].forEach((cls) => {
                        let class_id = cls;
                        let classObj = classIdToClass(class_id);
                        // @todo get the class name based on the class id
                        class_name += '-' + classObj.name;

                        class_value += '-' + class_id;
                        tags.push(classObj);
                    });

                    class_name += ']';
                    // check if the class is already in the tagsData
                    let found = tagsData.find(tag => tag.value === class_value);
                    if (!found) {
                        tagsData.push({
                            value: class_value,
                            text: class_name,
                            tag: classObj,
                            tags: tags,
                            classes:union[1]
                        });
                    }

                });
            }
            // get the model and set if is caption
            if (zone.model) {
                if (availableModels && availableModels.length > 0) {
                    let modelInfo = availableModels.find(m => m.name === zone.model);
                    if (modelInfo) {
                        zone.caption = modelInfo.captioning_flag;
                    }
                }
            }
            displaydata.push({
                zone: {
                    value: index,
                    caption: zone.caption || false,
                    traffic_lights: trafficLights.filter((light) => (zone.traffic_light_ids || []).map(Number).includes(light.id)),
                    id: zone.id,
                    label: "Zona " + index++
                },
                data: {
                    zone: zone,
                    objects: tagsData,
                    analizedData: analizedData
                }
            });
        });
        setDisplayInfo(displaydata);
        console.log("Alarm display info set:", displaydata);

    }, [zones, tags, allTags, baseCaptioningFlag, trafficLights]);
    const handleClick = () => {
        console.log('Add Alarm');
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    };

    if (displayInfo.length === 0) {
        return (
            <div>Loading...</div>
        );
    }

    const [sx, setSX] = useState({sx: {width: '80%'}});


    const CartBadge = styled(Badge)`
        & .${badgeClasses.badge} {
            top: -12px;
            right: -6px;
        }
    `;
    const alarmsCount = alarms.length;
    return (
        <div>
            <Button variant="contained" color={!disabled?"primary":"secondary"} onClick={handleClick}
                    startIcon={<AccessAlarmsIcon fontSize="small"/>}
                    size="small">Alarm Management
            </Button>
        <CartBadge badgeContent={alarmsCount} overlap="circular" variant="outlined" color="error"/>
            <Drawer
                anchor="right"
                open={show}
                onClose={handleClose}
                PaperProps={sx}
            >
                <Box sx={{p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <IconButton onClick={handleClose}>
                        <CloseIcon/>
                    </IconButton>
                </Box>
                <Box sx={{p: 2}}>
                    <AlarmDashboard
                        alarms={alarms}
                        disabled={disabled}
                        displayInfo={displayInfo}
                        onUpdate={onUpdate}
                        allTags={allTags}
                        onClose={handleClose}
                        setSX={setSX}
                        selectedHornId={selectedHornId}/>
                </Box>
            </Drawer>
        </div>
    );
}
